export function parseAIRespose(aicontent) {

  const projectRegex = /\[PROJECTS\]([\s\S]*?)\[\/PROJECTS\]/;
  const match = aicontent.match(projectRegex);
  const cvDwonload = /\[DOWNLOAD_CV\]/;
  const emailRegex = /\[SEND_EMAIL\|(.+?)\|(.+?)\|(.+?)\]/;
  const blog = /\[BLOG\]([\s\S]*?)\[\/BLOG\]/;

  const matchBlog = aicontent.match(blog);
  const matchContactMe = aicontent.match(emailRegex);
  const downloadCV = cvDwonload.test(aicontent);

  const userData = matchContactMe
    ? {
        name: matchContactMe[1].trim(),
        email: matchContactMe[2].trim(),
        message: matchContactMe[3].trim(),
      }
    : null;

  const text = aicontent
    .replace(projectRegex, "")
    .replace(cvDwonload, "")
    .replace(emailRegex, "")
    .replace(blog, "")
    .trim();

  const blogPosts = matchBlog
    ? matchBlog[1]
        .trim()
        .split("\n")
        .filter((line) => line.includes("|"))
        .map((line) => {
          const [title, ...descParts] = line.split("|").map((s) => s.trim());
          return { title, desc: descParts.join("|") };
        })
    : [];

  if (!match)
    return {
      text: text,
      projects: [],
      downloadCV,
      userData,
      matchBlog: blogPosts,
    };

  const projects = match[1]
    .trim()
    .split("\n")
    .map((line) => {
      const [title, desc] = line.split("|").map((s) => s.trim());
      return { title, desc };
    });


  return { text, projects, downloadCV, userData, matchBlog: blogPosts };
}
